module.exports = __webpack_public_path__ + "img/blueLogo.a54c9b4e.png";